<div class="flex flex-col gap-2">
    @if (label(); as label) {
        <app-label [required]="required()">{{ label }}</app-label>
    }
    @if (hint(); as hint) {
        <app-hint>{{ hint }}</app-hint>
    }
    <div class="relative flex w-full min-w-0 flex-col gap-3 sm:gap-6" [ngClass]="{ 'md:flex-row': direction() === 'row' }">
        @if (isLoading()) {
            <div class="absolute inset-0 z-10 flex items-center justify-center bg-white/60 backdrop-blur-sm rounded-lg">
                <app-icon name="svg-spinners:180-ring" class="size-8 text-blue-600" />
            </div>
        }
        @if (items().length !== maxlength()) {
            <div class="flex w-full min-w-0 flex-col gap-2">
                <div
                    class="flex min-h-32 w-full min-w-0 cursor-pointer flex-col items-center justify-center gap-4 rounded-lg border-2 border-dashed border-gray-200 p-4 transition-all hover:border-primary hover:bg-primary-50 sm:min-w-[20rem]"
                    [class.bg-primary-50]="isDragOvered()"
                    [class.border-primary]="isDragOvered()"
                    [class.bg-white]="!isDragOvered()"
                    [ngClass]="{ 'md:min-h-[18.75rem]': direction() === 'row' }"
                    (click)="inputRef.click()"
                    (dragover)="onDragOver($event)"
                    (dragleave)="onDragLeave($event)"
                    (drop)="onFileDrop($event)"
                >
                    <app-icon name="ic:baseline-upload-file" class="w-8 h-8 text-primary" />
                    <div class="flex flex-col gap-1 text-center">
                        <p class="text-sm text-gray-800">{{ type() === 'image' ? '사진' : '파일' }}을 드래그하여 올려놓으세요</p>
                        <p class="text-sm text-gray-500">또는 클릭해서 선택이 가능합니다</p>
                    </div>
                </div>
                @if (maxlength() > 1) {
                    <div class="flex w-full text-sm text-gray-500">
                        <p>{{ items().length }} / {{ maxlength() }}</p>
                    </div>
                }
            </div>
        }
        @if (items(); as items) {
            <div
                cdkDropList
                [cdkDropListData]="items"
                [cdkDropListDisabled]="items.length < 2"
                (cdkDropListDropped)="onDrop($event)"
                class="flex w-full min-w-0 flex-col gap-2 sm:min-w-[15rem]"
            >
                @for (item of items; track $index) {
                    <div cdkDrag class="flex w-full min-w-0 justify-between gap-2.5 rounded-md border border-gray-200 bg-white p-2.5">
                        <div class="flex min-w-0 items-center gap-2.5">
                            @if (item.isImage) {
                                <img [src]="item.url" class="rounded-md cursor-pointer w-9 h-9" (click)="openImage(item.url)" />
                            } @else {
                                <app-icon name="ic:outline-insert-drive-file" class="block w-6 h-6 bg-gray-700" />
                            }
                            <div class="flex min-w-0 flex-col gap-1">
                                <p
                                    class="w-full max-w-[11rem] truncate text-sm text-gray-700 sm:max-w-[18rem] lg:max-w-[25rem]"
                                    [ngClass]="{ 'md:max-w-[7rem]': direction() === 'row' }"
                                >
                                    {{ item.filename }}
                                </p>
                            </div>
                        </div>
                        <div class="flex items-center gap-4">
                            <app-icon
                                name="ic:outline-close"
                                class="w-5 h-5 text-gray-700 cursor-pointer"
                                (click)="onDeleteFile(item.url, item.filename)"
                            />
                        </div>
                    </div>
                }
            </div>
        }
    </div>
</div>
<input #inputRef hidden type="file" multiple [accept]="accept()" />
